  (function () {
    function initCaratSlider(groupEl) {
      const area = groupEl.querySelector('.cw-slider-area');
      if (!area || area.dataset.cwInit) return;
      area.dataset.cwInit = 'true';

      const minR = area.querySelector('.range-min');
      const maxR = area.querySelector('.range-max');
      const fill = area.querySelector('.cw-fill');
      const minDisp = groupEl.querySelector('.min-dimensions-display');
      const maxDisp = groupEl.querySelector('.max-dimensions-display');
      const checks = area.querySelectorAll('.dimension-checkbox');

      if (!minR || !maxR || !fill || !minDisp || !maxDisp) return;

      const bound_min = parseFloat(minR.min);
      const bound_max = parseFloat(minR.max);
      const GAP = parseFloat(minR.step) || 0.1;

      function pct(v) {
        return (((v - bound_min) / (bound_max - bound_min)) * 100).toFixed(2) + '%';
      }

      function render() {
        const lo = parseFloat(minR.value);
        const hi = parseFloat(maxR.value);

        fill.style.left = pct(lo);
        fill.style.right = (100 - parseFloat(pct(hi))).toFixed(2) + '%';

        minDisp.textContent = lo.toFixed(1);
        maxDisp.textContent = hi.toFixed(1);

        const mid = bound_min + (bound_max - bound_min) / 2;
        minR.style.zIndex = lo >= mid ? 5 : 4;
        maxR.style.zIndex = lo >= mid ? 4 : 5;

        checks.forEach((cb) => {
          const v = parseFloat(cb.dataset.value);
          cb.checked = v >= lo && v <= hi;
        });
      }

      let applyTimer = null;

      function scheduleApply() {
        clearTimeout(applyTimer);
        applyTimer = setTimeout(() => {
          const paramName = area.dataset.paramName;
          const params = new URLSearchParams(window.location.search);
          params.delete(paramName);
          area.querySelectorAll('.dimension-checkbox:checked').forEach((cb) => {
            params.append(paramName, cb.value);
          });
          window.location.search = params.toString();
        }, 800);
      }

      minR.addEventListener('input', () => {
        const lo = parseFloat(minR.value);
        const hi = parseFloat(maxR.value);
        if (lo >= hi - GAP) {
          minR.value = (hi - GAP).toFixed(1);
        }
        render();
        scheduleApply();
      });

      maxR.addEventListener('input', () => {
        const lo = parseFloat(minR.value);
        const hi = parseFloat(maxR.value);
        if (hi <= lo + GAP) {
          maxR.value = (lo + GAP).toFixed(1);
        }
        render();
        scheduleApply();
      });

      render();
    }

    function observeFilterGroups() {
      document.querySelectorAll('details[data-filter-group]').forEach((group) => {
        // Init immediately if already open
        if (group.hasAttribute('open')) initCaratSlider(group);

        // Watch for open/close toggle on <details>
        new MutationObserver(() => {
          if (group.hasAttribute('open')) initCaratSlider(group);
        }).observe(group, { attributes: true, attributeFilter: ['open'] });
      });
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeFilterGroups);
    } else {
      observeFilterGroups();
    }

    const filterBtn = document.querySelector('#filters-btn');
    const filterCloseBtn = document.querySelector('.side-filters-close');
    const sideFilters = document.querySelector('#side-filters-dwr');

    // Mobile breakpoint (≤ 991px)
    const isMobile = window.matchMedia('(max-width: 991px)');

    // Open toggle (only on mobile)
    if (filterBtn && sideFilters) {
        filterBtn.addEventListener('click', () => {
            if (isMobile.matches) {
                sideFilters.classList.toggle('open');
            }
        });
    }

    // Close button (only on mobile)
    if (filterCloseBtn && sideFilters) {
        filterCloseBtn.addEventListener('click', () => {
            if (isMobile.matches) {
                sideFilters.classList.remove('open');
            }
        });
    }

    // Reset when switching to desktop
    isMobile.addEventListener('change', () => {
        if (!isMobile.matches) {
            sideFilters.classList.remove('open');
        }
    });
  })();